// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_4f720283bf--wrapper--W5rqj","text":"_4f720283bf--text--y2IGR"};